<template>
	<div>
		<main class="flex flex-col min-h-screen items-between">
			<AppHeader />
			<Nuxt />
			<FooterComponent />
		</main>

		<NotificationSlideoutComponent
			v-if="$store.getters['user/loggedIn']"
			:open="$store.state.notification.isSlideoutOpen"
			@close="$store.dispatch('notification/toggleSlideout')"
		/>
		<ToastContainerComponent />
		<PortalTarget name="tooltip-root" multiple />
	</div>
</template>

<script>
import AppHeader from '~/components/Header/AppHeader'
import FooterComponent from '~/components/footer'
import ToastContainerComponent from '~/components/toast-container'
import NotificationSlideoutComponent from '~/components/Notifications/NotificationsSlideout'

export default {
	components: {
		AppHeader,
		FooterComponent,
		ToastContainerComponent,
		NotificationSlideoutComponent
	}
}
</script>
